<script>
    import BigSingleVideoTile from "./BigSingleVideoTile.svelte";
    export let videos = []

</script>


<div class="vec-flex vec-flex-col">
    <h2 class="vec-text-lg vec-mb-4">Up Next</h2>
    <div class="vec-flex vec-flex-col xl:vec-flex-row">
        {#each videos as video}
            <BigSingleVideoTile video={video.preview} on:video-clicked/>
        {/each}
    </div>
</div>
